import "./Header.css";

import { Link } from "react-router-dom";
import { Avatar, ButtonDropdown, Card, Text } from "@geist-ui/react";
export default function Header(props) {
  return (
    <Card hoverable className="navbar">
      <ul>
        <li className="nav-link">
          <Link className="home-link" to="/">
            Colaborator
          </Link>
        </li>
        <li className="nav-link" style={{ float: "right" }}>
          <ButtonDropdown auto>
            <ButtonDropdown.Item main>
              <Avatar src={props.avatarUrl} size="small" />
              <Text style={{ marginLeft: "10px" }}>{props.avatarName}</Text>
            </ButtonDropdown.Item>
            <ButtonDropdown.Item
              type="error"
              onClick={() => props.removeCookie("colabAuth")}
            >
              Logout
            </ButtonDropdown.Item>
          </ButtonDropdown>
        </li>
      </ul>
    </Card>
  );
}

Header.defaultProps = {
  avatarUrl:
    "https://avatars.githubusercontent.com/u/28642011?s=400&u=410fa98db67e3e52030423c0450ea5583c79506d&v=4",
  avatarName: "Saurav M. H",
};
